import type { ChildIssueFieldKeys } from '@atlassian/jira-issue-shared-types/src/common/types/children-issues-type.tsx';
import type { IssueKey, IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';

type ViewModeType = 'MODAL' | 'SIDEBAR' | 'DEFAULT';

type RapidViewMap = IssueKey[][];

export type OnIssueKeyChangeFn = (arg1: {
	fromIssueKey: IssueKey;
	toIssueKey: IssueKey;
	meta?: {
		location: string;
	};
}) => void;

export type IssueNavigatorData = {
	issueKey: string;
	issueKeys: (string | undefined)[];
	knownIssueKeys: string[];
	issuesCount: number;
	getIssueUrl?: (issueKey: IssueKey, backButtonUrl?: string) => string;
};

export type IssueContext = {
	analyticsSource: string | undefined;
	backButtonUrl: string | undefined;
	issueNavigatorData?: IssueNavigatorData;
	boardId: number | undefined;
	boardType: string | undefined;
	childIssuesLimit?: number | null | undefined;
	childIssuesIssueLimitUrls?: Record<ChildIssueFieldKeys, string | undefined>;
	estimationStatistic: string | undefined;
	isLoadedWithPage: boolean;
	isLoading: boolean;
	isModal: boolean;
	isSpaEnabled: boolean;
	issueKey: IssueKey;
	isArchived?: boolean;
	isClassifyEditEnabled?: boolean;
	issueId?: IssueId;
	loginRedirectUrl: string | undefined;
	maxTokenLength: number;
	rapidViewId: number | undefined;
	rapidViewMap: RapidViewMap | undefined;
	viewMode: ViewModeType | undefined;
	onIssueKeyChange: OnIssueKeyChangeFn | undefined;
	viewScreenId?: number | undefined;
	isAiOptInEnabled?: boolean;
	isAiEnabledForIssue?: boolean | null;
	issueType?: string;
	issueHierarchyLevel?: number;
	aiFeaturesOnboardingSpotlight?: AiFeaturesOnboardingSpotlightType;
};

export type State = IssueContext;

export type StoreApi = StoreActionApi<State>;

export type IssueContextServiceActions = {
	setIssueContext: (issueContext: IssueContext) => void;
	mergeIssueContext: (partialIssueContext: Partial<IssueContext>) => void;
	getChildIssuesLimit: () => number;
	getMaxTokenLength: () => number;
	getIsLoadedWithPage: () => boolean;
	getBackButtonUrl: () => string | undefined;
	getIsSpaEnabled: () => boolean;
	getIssueKey: () => IssueKey;
	// --NEXTLINE-- remove conditional when cleaning up: gic.positioning
	setDetailViewAsModal?: () => void;
	setDetailViewAsSidebar?: (willSave?: boolean) => void;
	resetDetailView?: (willSave?: boolean) => void;
};

export const AiFeaturesOnboardingItemsTypes = {
	DRAFT_PILL: 'DRAFT_PILL',
	SUMMARIZE_COMMENTS: 'SUMMARIZE_COMMENTS',
	SMART_RELATED_ISSUES: 'SMART_RELATED_ISSUES',
	AI_CONTEXT_PANEL: 'AI_CONTEXT_PANEL',
};

export type AiFeaturesOnboardingSpotlightType = {
	currentSpotlightItem:
		| (typeof AiFeaturesOnboardingItemsTypes)[keyof typeof AiFeaturesOnboardingItemsTypes]
		| null;
	presentSpotlights: Array<{ name: string; flag: boolean }>;
};
